import { Component, Input, OnInit } from '@angular/core';
import { Blog } from './blog';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html'
})
export class BlogComponent implements OnInit {

  imageUrl: string = '';
  @Input() blog: Blog;

  ngOnInit(): void {
    if (this.blog && this.blog.fields.image.fields.file.url) {
      this.imageUrl = 'https:' + this.blog.fields.image.fields.file.url;
    }
  }

}
